// extracted by mini-css-extract-plugin
export default {"cls1":"o7dyPpRGS7Hk3DZ3Rvex","cls2":"_eb09N54cJV5XQTGFP5Z o7dyPpRGS7Hk3DZ3Rvex"};